/**
 * 運搬ルート
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/transport_routes`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      limit: 50,
      route_name: null,
      trader_name: null,
      without_invisible: true,
    },
  }
}

const transport_routes = {
  namespaced: true,
  state: getDefaultState(),
  getters: {},
  actions: {
    /**
     *
     * @param dispatch
     * @param commit
     * @param state
     * @param route_name
     * @param trader_name { string }
     * @param without_invisible
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { route_name, trader_name, without_invisible, page, limit }) {
      dispatch('saveCondition', { route_name: route_name, trader_name: trader_name, without_invisible: without_invisible, limit: limit})
      const params = { route_name: route_name, trader_name: trader_name, without_invisible: without_invisible, page: page, limit: limit }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_TRANSPORT_ROUTE_PAGINATION, { content })
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.patch(api_path, params).then( data => {
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(data.content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    /**
     * 運搬ルートのテナント内の件数取得
     * @param commit
     * @return {Promise<unknown>}
     */
    check ({ commit }, { without_invisible }) {
      const params = { without_invisible }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    /**
     * 検索条件の保存
     * @param commit
     * @param state
     * @param route_name
     * @param trader_name
     * @param without_invisible
     * @param limit
     */
    saveCondition ({ commit, state }, { route_name, trader_name, without_invisible,limit }) {
      const _route_name = (route_name !== undefined) ? route_name : state.condition.route_name
      const _trader_name = (trader_name !== undefined) ? trader_name : state.condition.trader_name
      const _without_invisible = (without_invisible !== undefined) ? without_invisible : state.condition.without_invisible
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const params = { route_name: _route_name, trader_name: _trader_name, without_invisible: _without_invisible, limit: _limit}
      commit(types.DRIVER_TRANSPORT_ROUTE_CONDITION, { params })
    },
    /**
     * 保存された検索条件のクリア
     * @param commit
     */
    resetState ({ commit }) {
      commit(types.DRIVER_TRANSPORT_ROUTE_RESET_CONDITION)
    },
    /**
     * 保存されたページ情報のクリア
     * @param commit
     */
    resetPagination ({ commit }) {
      commit(types.DRIVER_TRANSPORT_ROUTE_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_TRANSPORT_ROUTE_CONDITION] (state, { params }) {
      state.condition.route_name = params.route_name
      state.condition.trader_name = params.trader_name
      state.condition.without_invisible = params.without_invisible
      state.condition.limit = params.limit
    },
    [types.DRIVER_TRANSPORT_ROUTE_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_TRANSPORT_ROUTE_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_TRANSPORT_ROUTE_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
  },
}

export default transport_routes

